import {
    CHECKOUT_SUBMIT,
    CHECKOUT_ALLOW_PARTIAL,
    CHECKOUT_SUBMIT_ERROR,
    CHECKOUT_SET_CUSTOMER_INFO,
    CHECKOUT_SET_CAMPAIGN_CODE,
    CHECKOUT_SET_DELIVERY,
    CHECKOUT_SET_DELIVERY_ADDRESSES,
    CHECKOUT_SET_DELIVERY_DATE,
    CHECKOUT_SET_PAYMENT,
    CHECKOUT_SET_ORDER_NOTE,
    CHECKOUT_ACCEPT_TERMS_OF_CONDITION,
    CHECKOUT_SET_PRIVATE_CUSTOMER,
    CHECKOUT_SET_PAYMENT_WIDGET,
    CHECKOUT_SET_SELECTED_COMPANY_ADDRESS,
    CHECKOUT_SET_SELECTED_DELIVERY_ADDRESS,
    CHECKOUT_SET_SIGN_UP,
    CHECKOUT_SET_RESELLER,
    CHECKOUT_SET_PARTIAL_DELIVERIES,
    CHECKOUT_SET_GENERAL_VALUES,
    CHECKOUT_OPEN_ADD_ADDRESS_MODAL,
    CHECKOUT_UPDATE_PAYLOAD,
    CHECKOUT_SET_SELECTED_DELIVERY_CONDITION,
    CHECKOUT_SET_SELECTED_OUR_REFERENCE,
    CHECKOUT_UPDATE_SELECTED_DELIVERIES

} from '../Actions/Checkout.action';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
    payload: {
        alternativeAddress: {},
        customerDetails: {},
        selectedCompanyAddressId: null,
        selectedDeliveryMethod: {},
        selectedPaymentMethod: {},
        campaignCode: '',
        orderNote: {},
        paymentWidget: null,
        isBusinessCustomer: false,
        signUp: false,
        acceptTermsOfCondition: false,
        authenticated: false,
        deliveryMethods: [],
        paymentMethods: [],
        billingAddresses: [],
        deliveryAddresses: [],
        responseUrl: '',
        cancelUrl: '',
        redirectUrl: '',
        
        releaseOrder: false,
        disableReleaseOrder: false,
        textExternal1: '',
        textExternal2: '',
        orderType: '',
        offerValidTo: '',
        orderTextInternal: '',
        newAddressModalIsOpen: true,
        orderPlacer: true,
        ordinaryOrderMailReceivers: true,
        freeTextMailReceivers: '',
        selectedDeliveryCondition: {},
        yourReferenceName: '',
        orderRows: [],
        countries: [],
        country: ''
    },

    isSubmitting: false,
    errors: {},
    result: {},

    
}

export const checkout = (state = defaultState, action) => {
    const { type, payload, selectedDeliveries } = action;
    switch (type) {
        case CHECKOUT_UPDATE_SELECTED_DELIVERIES:
            return {
                ...state,
                cart: {
                    ...state.cart,
                    selectedDeliveries: selectedDeliveries
                }
            }
        case CHECKOUT_SUBMIT_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            }
        case CHECKOUT_SUBMIT:
            return {
                ...state,
                ...payload,
            };
        case CHECKOUT_SET_CUSTOMER_INFO:
            return {
                ...state,
                payload: {
                    ...state.payload,
                    [payload.key]: {
                        ...state.payload[payload.key],
                        ...payload.data,
                    }
                },
            }
        case CHECKOUT_SET_RESELLER:
        case CHECKOUT_ALLOW_PARTIAL:
        case CHECKOUT_SET_DELIVERY_DATE:
        case CHECKOUT_SET_DELIVERY:
        case CHECKOUT_SET_PAYMENT:
        case CHECKOUT_SET_ORDER_NOTE:
        case CHECKOUT_SET_PAYMENT_WIDGET:
        case CHECKOUT_SET_PRIVATE_CUSTOMER:
        case CHECKOUT_SET_SIGN_UP:
        case CHECKOUT_SET_SELECTED_COMPANY_ADDRESS:
        case CHECKOUT_SET_SELECTED_DELIVERY_ADDRESS:
        case CHECKOUT_ACCEPT_TERMS_OF_CONDITION:
        case CHECKOUT_SET_CAMPAIGN_CODE:
        case CHECKOUT_SET_GENERAL_VALUES:
        case CHECKOUT_OPEN_ADD_ADDRESS_MODAL:
        case CHECKOUT_SET_DELIVERY_ADDRESSES:
        case CHECKOUT_UPDATE_PAYLOAD:
        case CHECKOUT_SET_SELECTED_DELIVERY_CONDITION:
        case CHECKOUT_SET_SELECTED_OUR_REFERENCE:
            return {
                ...state,
                payload: {
                    ...state.payload,
                    ...payload,
                }
            }
        default:
            return state;
    }
}